import { tsValidateArray, tsValidateDynamicObject, tsValidateString, tsValidateUniqueId, tsValidator_arrayOfUniqueIds } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
const Validator_ModifiableProps = {
    diseaseProfileId: tsValidateUniqueId,
    referenceIds: tsValidator_arrayOfUniqueIds,
    variables: tsValidateArray({
        variableId: tsValidateUniqueId,
        tagIds: tsValidateArray(tsValidateDynamicObject(tsValidateArray(tsValidateString()), tsValidateString())),
    }),
};
const Validator_GeneratedProps = {
    _firstVarId: tsValidateUniqueId,
    _variableIds: tsValidateArray(tsValidateUniqueId),
    _tagIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_MultiVar = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'multi-vars',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'multi-var'
    },
    backend: {
        name: 'multi-vars'
    },
    entityName: 'MultiVar',
    dependencies: {
        'diseaseProfileId': {
            dbKey: 'disease-profiles',
            fieldType: 'string'
        },
        'referenceIds': {
            dbKey: 'references',
            fieldType: 'string[]'
        },
        '_firstVarId': {
            dbKey: 'variables',
            fieldType: 'string'
        },
        '_variableIds': {
            dbKey: 'variables',
            fieldType: 'string[]'
        },
        '_tagIds': {
            dbKey: 'tags',
            fieldType: 'string[]'
        },
    }
};
//# sourceMappingURL=db-def.js.map